/**
* A module for registration related functionality.
*/
import { LOG_OUT_REGISTRANT_SUCCESS, LOG_IN_REGISTRANT_SUCCESS } from './registrantLogin/actionTypes';
import {
  CREATE_REG_CART_PENDING, CREATE_REG_CART_SUCCESS, CREATE_REG_CART_FAILURE,
  UPDATE_REG_CART_PENDING, UPDATE_REG_CART_SUCCESS, UPDATE_REG_CART_FAILURE,
  FINALIZE_CHECKOUT_PENDING, FINALIZE_CHECKOUT_SUCCESS, FINALIZE_CHECKOUT_FAILURE,
  START_CANCEL_REGISTRATION_CHECKOUT_PENDING, START_CANCEL_REGISTRATION_CHECKOUT_SUCCESS,
  START_CANCEL_REGISTRATION_CHECKOUT_FAILURE,
  START_MODIFICATION_PENDING, START_MODIFICATION_SUCCESS, START_MODIFICATION_FAILURE,
  INITIATE_CANCEL_REGISTRATION_PENDING, INITIATE_CANCEL_REGISTRATION_SUCCESS,
  FINALIZE_CANCEL_REGISTRATION_PENDING, FINALIZE_CANCEL_REGISTRATION_SUCCESS,
  FINALIZE_DECLINE_REGISTRATION_SUCCESS,
  FINALIZE_CHECKOUT_PAYMENT_FAILURE,
  RESTORE_REG_CART_PENDING, RESTORE_REG_CART_SUCCESS, ADD_GROUP_MEMBER_SUCCESS,
  ADD_GROUP_MEMBER_PENDING, ADD_GROUP_MEMBER_FAILURE, CHECKOUT_FAILURE
} from './registrationForm/regCart/actionTypes';
import {
  NOT_REGISTERING, STARTING_REGISTRATION, REGISTERING, SAVING_REGISTRATION,
  CHECKING_OUT, CHECKED_OUT, CANCELLING,
  FINALIZED_CANCEL_REGISTRATION, DECLINED_REGISTRATION
} from './registrationIntents';

const initialState = {
  registrationIntent: NOT_REGISTERING,
  checkoutProgress: 0,
  lastSavedRegCart: null
};

/**
* Reducer to keep track of the status of the reg cart
*/
export default function regCartStatusReducer(state = initialState, action) {
  switch (action.type) {
    case CREATE_REG_CART_PENDING:
    case ADD_GROUP_MEMBER_PENDING:
    case RESTORE_REG_CART_PENDING:
    case START_MODIFICATION_PENDING:
      return { ...state, registrationIntent: STARTING_REGISTRATION };
    case UPDATE_REG_CART_PENDING:
      return { ...state, registrationIntent: SAVING_REGISTRATION };
    case CREATE_REG_CART_SUCCESS:
    case ADD_GROUP_MEMBER_SUCCESS:
    case RESTORE_REG_CART_SUCCESS:
    case UPDATE_REG_CART_SUCCESS:
      return {
        ...state,
        registrationIntent: REGISTERING,
        lastSavedRegCart: action.payload.savedRegCart || action.payload.regCart,
        modificationStartRegCart: action.payload.modificationStartRegCart || state.modificationStartRegCart
      };
    case START_MODIFICATION_SUCCESS:
      return {
        ...state,
        registrationIntent: REGISTERING,
        lastSavedRegCart: action.payload.regCart,
        modificationStartRegCart: action.payload.regCart
      };
    case FINALIZE_CHECKOUT_PENDING:
      return {
        ...state,
        registrationIntent: CHECKING_OUT,
        checkoutProgress: action.payload.checkoutProgress
      };
    case FINALIZE_CHECKOUT_SUCCESS:
      // TODO: handle partial checkout once the API supports it
      return {
        ...state,
        registrationIntent: CHECKED_OUT,
        checkoutProgress: 100
      };
    case CREATE_REG_CART_FAILURE:
    case START_MODIFICATION_FAILURE:
      return {
        ...state,
        registrationIntent: NOT_REGISTERING
      };
    case UPDATE_REG_CART_FAILURE:
    case ADD_GROUP_MEMBER_FAILURE:
    case FINALIZE_CHECKOUT_PAYMENT_FAILURE:
      return {
        ...state,
        registrationIntent: REGISTERING
      };
    case INITIATE_CANCEL_REGISTRATION_PENDING:
    case INITIATE_CANCEL_REGISTRATION_SUCCESS:
    case START_CANCEL_REGISTRATION_CHECKOUT_PENDING:
    case START_CANCEL_REGISTRATION_CHECKOUT_SUCCESS:
    case FINALIZE_CANCEL_REGISTRATION_PENDING:
      return {
        ...state,
        registrationIntent: CANCELLING
      };
    case START_CANCEL_REGISTRATION_CHECKOUT_FAILURE:
      return {
        // TODO: add error handling
        ...state,
        registrationIntent: CHECKED_OUT
      };
    case FINALIZE_CANCEL_REGISTRATION_SUCCESS:
      return {
        ...state,
        registrationIntent: FINALIZED_CANCEL_REGISTRATION
      };
    case FINALIZE_CHECKOUT_FAILURE:
      // TODO: add error handling
      return state;
    case FINALIZE_DECLINE_REGISTRATION_SUCCESS:
      return {
        ...state,
        registrationIntent: DECLINED_REGISTRATION,
        lastSavedRegCart: action.payload.regCart
      };
    case LOG_IN_REGISTRANT_SUCCESS:
      return {
        ...state,
        registrationIntent: CHECKED_OUT
      };
    case LOG_OUT_REGISTRANT_SUCCESS:
      return initialState;
    case CHECKOUT_FAILURE:
      return {
        ...state,
        registrationIntent: REGISTERING
      };
    default:
      return state;
  }
}
